// libraries.
import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

// selectors.
import { TabsDocumentsReviewOption } from '@domains/documents-review/store/slices/document-review-slice';

// components.
import { useSuggestionsAutoCompleteDocs } from '@domains/documents-review/hooks/useSuggestionsAutoCompleteDocs';
interface AutocompleteInfoLayoutProps {
  activeTab: TabsDocumentsReviewOption;
  setActiveTab: (tab: TabsDocumentsReviewOption) => void;
}

export const AutocompleteInfoLayout: React.FC<AutocompleteInfoLayoutProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const { isLoading, isFetching } = useSuggestionsAutoCompleteDocs();
  const showLoading = Boolean(isLoading || isFetching);

  const isSelected = activeTab === TabsDocumentsReviewOption.AUTOCOMPLETE;

  return (
    <div data-testid="autocomplete-info-layout">
      <div
        role="button"
        aria-selected={isSelected}
        className={`cursor tab-trigger ${isSelected ? 'selected-tab' : ''}`}
        onClick={() => setActiveTab(TabsDocumentsReviewOption.AUTOCOMPLETE)}
      >
        <span className="d-flex align-items-center">
          Autocompletado Info
          {showLoading && (
            <span
              className="ms-2 d-inline-flex align-items-center"
              data-testid="autocomplete-spinner"
            >
              <Spinner animation="border" role="status" size="sm" />
            </span>
          )}
        </span>
      </div>
    </div>
  );
};
